<template>
  <div>
    <div class="SelectYMDArea" :class="{ isPc: !isSp }">
      <InputLabel class="labelArea" :class="{ isPc: !isSp, isHasLabel: !isSp && required }" :required="required">
        {{ areaLabel }}
      </InputLabel>
      <div class="inputsArea" :class="{ isPc: !isSp }">
        <SelectBox
          v-model="selectedYear"
          class="inputItem"
          :class="{ isPc: !isSp }"
          placeholder-value="年"
          :has-error="hasError.year"
          :select-list="yearsList"
          :disabled="yearDisabled"
          @change="onChange"
        />
        <SelectBox
          v-model="selectedMonth"
          class="inputItem"
          :class="{ isPc: !isSp }"
          placeholder-value="月"
          :has-error="hasError.month"
          :select-list="monthList"
          :disabled="monthDisabled"
          @change="onChange"
        />
        <SelectBox
          v-model="selectedDay"
          class="inputItem"
          :class="{ isPc: !isSp }"
          placeholder-value="日"
          :has-error="hasError.day"
          :select-list="dayList"
          :disabled="dateDisabled"
          @change="onChange"
        />
      </div>
    </div>
    <div class="underInputArea" :class="{ isPc: !isSp }">
      <PartialErrorMessage :is-sp-flg="true" :error="errorFromOuter" class="partialErrorComponent" />
    </div>
  </div>
</template>

<script>
import InputLabel from '../Text/InputLabel.vue';
import SelectBox from './SelectBox.vue';
import PartialErrorMessage from '../PartialErrorMessage.vue';

/**
 * YearMonthDateをセレクトボックスで入力するためのコンポーネント
 */
export default {
  name: 'SelectYMDArea',
  components: {
    InputLabel,
    SelectBox,
    PartialErrorMessage,
  },
  props: {
    areaLabel: {
      type: String,
      required: true,
    },
    /**
     * 外部からのエラー
     * このコンポーネント自体はエラーを発出しない。
     * が、『未選択エラー』を外部から入れ込むケースがある。
     */
    errorFromOuter: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 初期値が存在する場合は以下3つのdefaultYear, defaultMonth, defaultDateに初期値を渡す
     */
    defaultYear: {
      type: String,
      required: false,
      default: '',
    },
    defaultMonth: {
      type: String,
      required: false,
      default: '',
    },
    defaultDate: {
      type: String,
      required: false,
      default: '',
    },
    yearDisabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    monthDisabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    dateDisabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      validationError: undefined,
      selectedYear: this.defaultYear,
      selectedMonth: this.defaultMonth,
      selectedDay: this.defaultDate,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    // SelectBoxのValueがStringのみなので文字列にしておく
    yearsList() {
      // 現在日時から100年前
      const oneHundredYearAgo = new Date().getFullYear() - 100;
      // 101年前から15年前までまでの86年分
      return [...Array(86).keys()].map((i) => (i + oneHundredYearAgo).toString()).reverse();
    },
    monthList() {
      return [...Array(12).keys()].map((i) => (i + 1).toString());
    },
    dayList() {
      if (['4', '6', '9', '11'].includes(this.selectedMonth)) {
        // 30日までの月
        return [...Array(30).keys()].map((i) => (i + 1).toString());
      }
      if (this.selectedMonth === '2') {
        // 2月
        if ((this.selectedYear % 4 === 0 && this.selectedYear % 100 !== 0) || this.selectedYear % 400 === 0) {
          // うるう年
          return [...Array(29).keys()].map((i) => (i + 1).toString());
        }
        // うるう年じゃない
        return [...Array(28).keys()].map((i) => (i + 1).toString());
      }
      // それ以外は31日まででる
      return [...Array(31).keys()].map((i) => (i + 1).toString());
    },
    // memo: 年月日は姓名と違い一括バリデなのでエラーは1つで良い
    // TODO: 現状だと年月日のいずれかを選択済みの場合でもすべて赤枠になってしまうので、hasErrorあたりでなんとかしてほしい
    // ここで再判定かObject詰め替え等行うのが良さそう
    hasError() {
      // errorFromOuterがfalsyならエラーない
      if (!this.errorFromOuter) {
        return {
          year: false,
          month: false,
          day: false,
        };
      }
      // errorFromOuterがlengthもってるならエラーあり
      if (this.errorFromOuter.length) {
        return {
          year: this.selectedYear === '',
          month: this.selectedMonth === '',
          day: this.selectedDay === '',
        };
      }
      return false;
    },
  },
  mounted() {
    // TODO: デフォルト値を20年前にする場合は下行のコメントアウトを外す
    // 120年前始まりにしているので『スクロールが長すぎるのでデフォルトを直近にしたい』との要望があったら外す
    // 特に要望でなければ納品前に消す
    // this.selectedYear = (new Date().getFullYear()-20).toString()
  },
  methods: {
    onChange() {
      // どれか1つでもfalsyならチェックもemitせず終わる
      if (!this.selectedYear || !this.selectedMonth || !this.selectedDay) return;
      // ↓年月日整合性チェックここから↓ //
      if (['4', '6', '9', '11'].includes(this.selectedMonth) && this.selectedDay === '31') {
        // 4月, 6月, 9月, 11月の時に31日を選択していたら30日に戻す
        this.selectedDay = '30';
      } else if (this.selectedMonth === '2' && parseInt(this.selectedDay, 10) > 28) {
        // 2月で29日以降のとき…
        if ((this.selectedYear % 4 === 0 && this.selectedYear % 100 !== 0) || this.selectedYear % 400 === 0) {
          // うるう年なら29にする
          this.selectedDay = '29';
        } else {
          // うるう年でないなら28にする
          this.selectedDay = '28';
        }
      }
      // ↑年月日整合性チェックここまで↑ //
      this.$emit('change', {
        year: this.selectedYear,
        month: this.selectedMonth,
        day: this.selectedDay,
      });
      this.$emit('watchValidation');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.SelectYMDArea {
  .labelArea.isPc {
    width: 120px;
    margin: auto 0;

    &.isHasLabel {
      width: 184px;
    }
  }

  &.isPc {
    display: flex;
  }
}

.inputsArea {
  display: flex;

  .inputItem {
    margin-left: 8px;

    &.isPc {
      width: 100px;
    }

    &:first-child {
      margin-left: 0;
    }
  }

  &.isPc {
    width: 432px;
  }

  .inputLeft {
    margin-right: 8px;
  }

  .inputCenter {
    margin-right: 8px;
  }
}

.underInputArea {
  &.isPc {
    margin-left: 184px;
  }

  .partialErrorComponent {
    margin-top: 8px;
  }
}
</style>
